import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import updateLayerIndex from 'common/src/modules/creativeTemplates/utils/updateLayerIndex';
import updateComps from './updateComps';
import {RootState} from 'common/src/redux/store';
import selectActiveLayer from './selectActiveLayer';
import {getActiveFormat} from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/utils/getActiveFormat';

interface DeleteLayersParams {
  layerIds: string[];
  compId?: string;
  activeFormat?: string;
}

const deleteLayers = createAsyncThunk(
  `${BreadcrumbName.AdBuilder}/deleteLayers`,
  async (
    {layerIds, compId, activeFormat}: DeleteLayersParams,
    {dispatch, getState},
  ): Promise<void> => {
    const state = getState() as RootState;
    const workingFormat = activeFormat ?? getActiveFormat();
    const comps = state.creativeTemplatePage.formatMovies.movies[workingFormat] || {};
    const activeCompId = compId ?? state.creativeTemplatePage.formatMovies.activeCompId;
    const activeLayerIds = state.creativeTemplatePage.formatMovies.activeLayerIds;

    const layersToDelete = comps[activeCompId]?.l.filter(
      (l) => !l.isLocked && layerIds.includes(l.id),
    );

    if (!layersToDelete || layersToDelete.length === 0) return;

    const indexesToDelete = layersToDelete.map((l) => +l.i);
    const deletedLayerIds = layersToDelete.map((l) => l.id);
    const shouldClearActiveLayers = deletedLayerIds.some((id) => activeLayerIds.includes(id));

    await dispatch(
      updateComps({
        compsUpdate: (oldComps) => ({
          ...oldComps,
          [activeCompId]: {
            ...oldComps[activeCompId],
            l: oldComps[activeCompId].l
              .filter(({id, isLocked}) => !layerIds.includes(id) || isLocked)
              .map((layer) =>
                updateLayerIndex(layer, (idx) => {
                  if (indexesToDelete.includes(idx)) return undefined;

                  return idx - indexesToDelete.filter((i) => i < idx).length;
                }),
              ),
          },
        }),
        activeFormat,
        replaceState: false,
      }),
    );

    if (shouldClearActiveLayers) {
      dispatch(selectActiveLayer({layerId: '', compId: activeCompId}));
    }
  },
);

export default deleteLayers;
